import React from 'react'

export const EditIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.74753 1.99998H2V14H14V6.2328L12.6667 7.56613V12.6666H3.33333V3.33331H8.4142L9.74753 1.99998Z"
      fill="#0A5546"
    />
    <path
      d="M12.3131 1.33331L14.6701 3.69034L13.2559 5.10455L10.8989 2.74753L12.3131 1.33331Z"
      fill="#0A5546"
    />
    <path
      d="M9.95609 3.69034L5.24205 8.40438L4.53494 11.4685L7.59907 10.7614L12.3131 6.04736L9.95609 3.69034Z"
      fill="#0A5546"
    />
  </svg>
)

export const FilterIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M7 5H9V11H7V9H3V7H7V5Z" fill="#0A5546" />
    <path d="M11 9H21V7H11V9Z" fill="#0A5546" />
    <path d="M15 13H17V15H21V17H17V19H15V13Z" fill="#0A5546" />
    <path d="M13 15H3V17H13V15Z" fill="#0A5546" />
  </svg>
)

export const ManageMenuIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.16819 4.40172C7.20248 2.45589 6.34529 1.33301 4.83663 1.33301H4.6652C3.15654 1.33301 2.29934 2.45589 2.33363 4.40172C2.30435 6.06342 2.92522 7.125 4.04674 7.39959L3.6454 14.6623H5.86553L5.45644 7.39925C6.57711 7.12414 7.19746 6.06275 7.16819 4.40172Z"
      fill="#0A5546"
    />
    <path
      d="M12.5003 5.22464L12.5088 5.23322H11.8445L11.5574 1.33301H10.8973L10.6102 5.23322H9.9547L9.96327 5.22464V1.34159H9.35466L8.81464 5.10462L8.81249 5.12592C8.80469 5.20329 8.79749 5.27468 8.79749 5.35324C8.79749 6.099 9.26895 6.76762 9.97184 7.02478L10.5364 7.23004L10.512 7.66159L10.469 8.38768H10.4711L10.1177 14.6623H12.3379L11.9911 8.38768H11.9945L11.9441 7.53749L11.9272 7.23006L12.4917 7.02478C13.1946 6.76762 13.6661 6.099 13.6661 5.35324C13.6661 5.27472 13.6589 5.20336 13.6511 5.12604L13.6489 5.10462L13.1089 1.34159H12.5003V5.22464Z"
      fill="#0A5546"
    />
  </svg>
)

export const CancelIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99761 16.6623C11.6784 16.6623 14.6623 13.6784 14.6623 9.99761C14.6623 6.31682 11.6784 3.33295 7.99761 3.33295C4.31682 3.33295 1.33295 6.31682 1.33295 9.99761C1.33295 13.6784 4.31682 16.6623 7.99761 16.6623ZM5.17005 8.11256L6.11258 7.17003L7.99763 9.05508L9.88268 7.17003L10.8252 8.11256L8.94016 9.99761L10.8252 11.8827L9.88268 12.8252L7.99763 10.9401L6.11258 12.8252L5.17005 11.8827L7.0551 9.99761L5.17005 8.11256Z"
      fill="#242529"
    />
  </svg>
)

export const OptionsIcon = ({ className }: { className?: string }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.5 12C7.5 13.1046 6.60457 14 5.5 14C4.39543 14 3.5 13.1046 3.5 12C3.5 10.8954 4.39543 10 5.5 10C6.60457 10 7.5 10.8954 7.5 12Z"
      fill="white"
    />
    <path
      d="M14.5 12C14.5 13.1046 13.6046 14 12.5 14C11.3954 14 10.5 13.1046 10.5 12C10.5 10.8954 11.3954 10 12.5 10C13.6046 10 14.5 10.8954 14.5 12Z"
      fill="white"
    />
    <path
      d="M19.5 14C20.6046 14 21.5 13.1046 21.5 12C21.5 10.8954 20.6046 10 19.5 10C18.3954 10 17.5 10.8954 17.5 12C17.5 13.1046 18.3954 14 19.5 14Z"
      fill="white"
    />
  </svg>
)

export const BellIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 2.25a6.75 6.75 0 0 0-6.75 6.75v3.4l-1.6 3.2A1.5 1.5 0 0 0 5 17.75h4.5a2.5 2.5 0 0 0 5 0H19a1.5 1.5 0 0 0 1.35-2.15l-1.6-3.2V9A6.75 6.75 0 0 0 12 2.25Zm1 15.5a1 1 0 0 1-2 0h2Zm-1-14a5.25 5.25 0 0 1 5.25 5.25v3.58l1.6 3.17H5.15l1.6-3.17V9A5.25 5.25 0 0 1 12 3.75Z"
      fill="#0A5546"
    />
  </svg>
)

export const CircleCrossIcon = ({ className }: { className?: string }) => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="45" cy="45" r="41.5" stroke="#D03A3A" strokeWidth="7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.1503 32.8497C59.1999 33.8992 59.1999 35.6008 58.1503 36.6503L49.3001 45.5L58.1503 54.3496C59.1343 55.3336 59.1958 56.8907 58.3348 57.9462L58.1503 58.1503C57.1008 59.1999 55.3992 59.1999 54.3496 58.1503L45.5 49.3001L36.6503 58.1503C35.6008 59.1999 33.8992 59.1999 32.8497 58.1503C31.8001 57.1008 31.8001 55.3992 32.8497 54.3496L41.6999 45.5L32.8497 36.6503C31.8657 35.6664 31.8042 34.1093 32.6652 33.0538L32.8497 32.8497C33.8992 31.8001 35.6008 31.8001 36.6503 32.8497L45.5 41.6999L54.3496 32.8497C55.3992 31.8001 57.1008 31.8001 58.1503 32.8497Z"
      fill="#DE3534"
    />
  </svg>
)
